import * as Types from '../../../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddSensorCommentMutationVariables = Types.Exact<{
  sensorId?: Types.InputMaybe<Types.Scalars['String']>;
  userId?: Types.InputMaybe<Types.Scalars['String']>;
  text: Types.Scalars['String'];
}>;


export type AddSensorCommentMutation = { __typename?: 'Mutation', createSensorComment?: { __typename?: 'createSensorCommentPayload', sensorComment?: { __typename?: 'SensorComment', id: string } | null } | null };


export const AddSensorCommentDocument = gql`
    mutation addSensorComment($sensorId: String, $userId: String, $text: String!) {
  createSensorComment(input: {sensor: $sensorId, user: $userId, text: $text}) {
    sensorComment {
      id
    }
  }
}
    `;
export type AddSensorCommentMutationFn = Apollo.MutationFunction<AddSensorCommentMutation, AddSensorCommentMutationVariables>;

/**
 * __useAddSensorCommentMutation__
 *
 * To run a mutation, you first call `useAddSensorCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSensorCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSensorCommentMutation, { data, loading, error }] = useAddSensorCommentMutation({
 *   variables: {
 *      sensorId: // value for 'sensorId'
 *      userId: // value for 'userId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAddSensorCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddSensorCommentMutation, AddSensorCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSensorCommentMutation, AddSensorCommentMutationVariables>(AddSensorCommentDocument, options);
      }
export type AddSensorCommentMutationHookResult = ReturnType<typeof useAddSensorCommentMutation>;
export type AddSensorCommentMutationResult = Apollo.MutationResult<AddSensorCommentMutation>;
export type AddSensorCommentMutationOptions = Apollo.BaseMutationOptions<AddSensorCommentMutation, AddSensorCommentMutationVariables>;